import '../styles/style.scss';

import './white-navbar';

import './polylang';

import './minimal-search';
